import { format } from "date-fns";

const FMT = "PP";

const base =
  "h-18 bg-neutral-800 active:bg-neutral-700 cursor-pointer active:scale-95 active:shadow-xl rounded-3xl border border-neutral-900 shadow-md shadow-neutral-300 w-32";

function CardRoom(props) {
  const { record, ctxView, onClick } = props;
  const { model, card_action = [] } = ctxView;
  const key = record.id;

  let actionDelete = false;
  if (card_action) {
    for (const action of card_action) {
      if (action === "delete") {
        actionDelete = true;
      }
    }
  }

  function handleClick(record) {
    onClick(record);
  }

  const state = `${model}.${record.registration_state}`;

  const arrival_date = format(record.arrival_date, FMT);
  const departure_date = format(record.departure_date, FMT);
  return (
    <div key={key} className={base} onClick={() => handleClick(record)}>
      <div className="flex h-3/5 mt-2">
        <span className="mt-auto mx-auto font-bold text-neutral-100 text-lg truncate">
          {record["room."].code}
        </span>
      </div>
      <div className="h-[1px] mx-auto mt-0 w-1/2 bg-amber-300" />
    </div>
  );
}

export default CardRoom;
